import { APP_ROUTES } from "@/constants/app-routes";

/**
 * The auth screen a signed-out user should land on: the login screen if they have
 * authenticated on this device before, otherwise the register screen.
 *
 * Single source of truth for the signed-out destination so every redirector
 * (PrivateAuthGuard, SplashScreen) agrees. The signed-IN destination is owned by
 * `resolvePostAuthRoute`.
 */
export const resolveSignedOutRoute = (hasSignedInBefore: boolean): string =>
  hasSignedInBefore ? APP_ROUTES.LOGIN : APP_ROUTES.REGISTER;
